import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Wallet } from "lucide-react";
import { api, errorText } from "@/lib/api";

const MODES = [["quarter", "1/4 Kelly"], ["half", "1/2 Kelly"], ["full", "Full Kelly"]];

export function ValueBankroll({ onSaved }) {
  const [s, setS] = useState(null);
  const [draft, setDraft] = useState("");
  const queue = useRef(Promise.resolve());
  useEffect(() => { api.get("/value/settings").then((r) => { setS(r.data); setDraft(String(r.data.bankroll)); }).catch(() => {}); }, []);
  // Saves run one after another so a blur save never lands after a later Kelly click.
  const save = (next) => { queue.current = queue.current.then(async () => {
    try {
      const { data } = await api.put("/value/settings", { bankroll: next.bankroll, kelly: next.kelly });
      setS(data); setDraft(String(data.bankroll)); onSaved();
    } catch (e) { toast.error(errorText(e)); }
  }); };
  if (!s) return null;
  const commit = () => { const v = parseFloat(draft); if (v > 0 && v !== s.bankroll) save({ ...s, bankroll: v }); else setDraft(String(s.bankroll)); };
  return (
    <div className="vs-bank" data-testid="value-bankroll">
      <Wallet size={15} />
      <label>Bankroll
        <input type="number" min="1" step="1" value={draft} onChange={(e) => setDraft(e.target.value)} onBlur={commit}
          onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()} data-testid="value-bankroll-input" />
      </label>
      <div className="tv-pills vs-tabs">
        {MODES.map(([k, label]) => (
          <button key={k} type="button" className={s.kelly === k ? "is-active" : ""} onClick={() => s.kelly !== k && save({ bankroll: parseFloat(draft) > 0 ? parseFloat(draft) : s.bankroll, kelly: k })} data-testid={`value-kelly-${k}`}>{label}</button>
        ))}
      </div>
      <span>Max {Math.round(s.cap * 100)}% per pick</span>
    </div>
  );
}
